/* eslint-disable */
import createStore from './store/create-store';
import { fromJS } from 'immutable';
import { combineReducers } from 'redux';

import { combine } from './utils/reducers';

import WorkersManager from './workers/workers';

import reducers from './modules';
import workers from './workers';

const workersManager = new WorkersManager(workers);

let localStorage = typeof window !== 'undefined' && window.localStorage;

if (localStorage) {
    try {
        localStorage.setItem('_test_', '_test_');
    } catch (e) {
        localStorage = null;
    }
}

let recentEvents = [];
if (localStorage) {
    try {
        recentEvents = JSON.parse(localStorage.getItem('recentEvents'));
    } catch (e) {
    }
}

const store = createStore({
    reducers: combine([
        combineReducers(reducers),
        workersManager.reducer
    ]),
    data: {
        routes: fromJS({

        }),
        customers: fromJS({
            list: {},
            update: {},
            transactions: {},
            opened: [],
            freebetCredits: {},
            validations: {}
        }),
        banners: fromJS({
            newBanner: {},
            allBanners: {},
            updateBanner: {},
            imageBanner: {},
            deleteBanner: {},
            bannerConfig: {}
        }),
        postcode: fromJS({

        }),
        user: fromJS({
            authenticated: typeof window !== 'undefined' && !!window.$userData,
            data: (typeof window !== 'undefined' && window.$userData) || {},
            login: {},
            logout: {}
        }),
        competitions: fromJS({
            items: {},
            collections: {}
        }),
        selections: fromJS({
            items: {},
            collections: {}
        }),
        participants: fromJS({
            items: {},
            collections: {},
            create: {}
        }),
        events: fromJS({
            items: {},
            collections: {},
            opened: [],
            recent: recentEvents || [],
            last: {},
            searchResult: {},
            tabUrl: {}
        }),
        markets: fromJS({
            items: {},
            marketsByEventId: {},
            collections: {}
        }),
        sports: fromJS({
            items: {},
            collections: {}
        }),
        tags: fromJS({
            items: {},
            collections: {}
        }),
        chats: fromJS({
            items: {}
        }),
        transactions: fromJS({
            items: {},
            collections: {}
        }),
        notifications: fromJS({
            items: {}
        }),
        betslip: fromJS({
            legs: {},
            bets: {},
            combinations: {},
            possibleBets: {},
            bonusEngineFreeBets: {}
        }),
        bets: fromJS({
            items: {},
            collections: {}
        }),
        reports: fromJS({
            runReport: {},
            items: {},
            collections: {}
        }),
        grades: fromJS({
            items: {},
            collections: {}
        }),
        marketTemplates: fromJS({
            items: {},
            collections: {}
        }),
        betTicker: fromJS({
            items: {}
        }),
        payments: fromJS({
            items: {},
            collections: {}
        }),
        roles: fromJS({
            items: {}
        }),
        relatedContingency: fromJS({
            allRelatedContingencyLabels: {},
            createRelatedContingencyLabel: {},
            updateRelatedContingencyLabel: {},
            addMarketsToTag: {},
            getMarketsForTag: {},
            deleteMarketsFromTag: {},
            eventInfoByTagId: {}
        }),
        permissions: fromJS({
            items: {},
            collections: {}
        }),
        staff: fromJS({
            items: {},
            collections: {}
        }),
        audits: fromJS({
            collections: {}
        }),
        countries: fromJS({
            items: {}
        }),
        liabilities: fromJS({
            items: {},
            limits: {},
            multiples: {},
            multiplesDetails: {},
            rumlegs: {},
            avgNetPayouts: {}
        }),

        systemSettings: fromJS({
            bogSettings: {},
            widgetSettings: {}
        }),
        bonuses: fromJS({
            items: {}
        }),
        ladders: fromJS({
            items: {}
        }),
        fraudAndCompliance: fromJS({
            items: {},
            collections: {}
        }),
        languages: fromJS({
            data: {}
        })
    }
});

const originalDispatch = store.dispatch;
store.dispatch = (...args) => {
    const result = originalDispatch.apply(store, args);

    // console.info('REDUX action', {
    //     args,
    //     result
    // });

    if (typeof window.$appState !== 'undefined') {
        $appState.reduxStore.forceSynchronisation();
    }

    return result;
};

workersManager.setDispatcher((action) => store.dispatch(action));

if (module.hot) {
    module.hot.accept(
        [ require.resolve('./modules'), require.resolve('./workers') ],
        () => {
            workersManager.setWorkers(require('./workers'));
            store.replaceReducer(combine([ combineReducers(require('./modules')), workersManager.reducer ]));
        }
     );
}

// window.demo = store.dispatch;

export default store;
